<template>
  <v-app>
    <layout/>
    <notifications/>
    <loading-dialog/>
    <error-dialog/>
    <!-- 공지 팝업 -->
    <v-dialog v-model="component_show" max-width="900px">
      <v-card class="top_title"> &nbsp; 공지사항</v-card>
      <v-card>
        <span>
          &nbsp; <input type="checkbox" id="chkToday"> &nbsp;5일동안 열지 않음 &nbsp;
          <v-btn variant="plain" size="small" @click="closeLayer">닫기</v-btn>
        </span>
      </v-card>
      <div class="main_content">
        <img src="@/assets/image/popup.jpg" width="100%">
      </div>
    </v-dialog>
  </v-app>
</template>

<script>
import envs from './envs'
import store from '@/store'
import router from '@/router'
import localStore from '@/utils/localStore'
import { isMobile, isTouchOneLogin } from '@/utils/check'
import { getToken, setToken } from '@/utils/token'
import '@/utils/shortcut'
import EventBus from '@/utils/eventBus'
import { getUserAuthSpecificMenu } from '@/api/manager/auth/userauth'
import layout from '@/layout'
import ErrorDialog from '@/layout/components/ErrorDialog'
import LoadingDialog from '@/layout/components/LoadingDialog'
import Notifications from '@/layout/components/Notifications'
import { confirmIfExit } from '@/api/greenCommon/confirmIfExit'
import Cookies from 'js-cookie'
// import { cordova } from '@/plugins/cordova'

let params = {}
let menuFlag = false
window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(
  str,
  key,
  value
) {
  params[key] = value
})
if (params.theme === 'page') {
  store.dispatch('SetNavigationDrawer', false)
  store.dispatch('SetHeaderUse', false)
  store.dispatch('SetFooterUse', false)
  store.dispatch('SetTagViewUse', false)
}
if (params.MenuId && params.token) {
  setToken(params.token)
  getUserAuthSpecificMenu({
    menu_id: params.MenuId,
    app_id: envs.systemId
  }).then(response => {
    menuFlag = false
  })
}

if (params.id && params.menuId) {
  store
    .dispatch('loginbyId', {
      userId: params.id
    })
    .then(response => {})
    .catch(reject => {
      // Login이 실패할 경우
      console.error('login fail:', reject)
    })
    .then(() => {
      store.dispatch('SetUserInfo').then(response => {
        // user 정보를 가져온 이후에 이동 및 메뉴 적용
        store.dispatch('GetMenus')
        Object.keys(store.state.user.buttonPermission).forEach(key => {
          if (
            store.state.user.buttonPermission[key].menu_id === params.menuId
          ) {
            menuFlag = true
          }
        })
        if (menuFlag === true) {
          console.log('해당메뉴 권한 있음', menuFlag)
        } else {
          // 메뉴 정보가 없는 사용자는 권한이 없는 경우 이므로 권한 없음 페이지로 이동
          router.push('/forbidden')
          console.log('해당메뉴 권한 없음', menuFlag)
        }
      })
    })
  menuFlag = false
}
// 최초 구동간 locale 셋팅
let locale = localStore.get('locale')
// Locale 정보를 셋팅한다.
store.dispatch('SetLocale', locale)

export default {
  name: 'App',
  components: {
    layout,
    ErrorDialog,
    LoadingDialog,
    Notifications
  },
  data() {
    return {
      component_show: false
    }
  },
  watch: {
    '$vuetify.theme.dark': function(newValue) {
      localStore.set('theme-dark', newValue + '')
      // realgrid theme 적용
      this.setRealGridTheme(newValue)
    }
  },
  mounted() {
    this.setRealGridTheme(localStore.get('theme-dark') === 'true')
    console.log(this.$route.name)
    this.initPopup()
  },
  created() {
    // Token 값을 기준으로 로그인 여부를 확인한다.
    // Store에 토큰 값이 없으면 로그인 화면으로 이동한다.
    // 참고: 토큰 값은 쿠키에 저장됨

    if (localStore.get('theme-dark') === null) {
      localStore.set('theme-dark', 'true')
    }
    this.$vuetify.theme.dark = localStore.get('theme-dark') === 'true'

    EventBus.$on('touchOneLogin', () => {
      this.callSetUserInfoTouchOne()
    })
    if (!isTouchOneLogin()) {
      if (router.currentRoute.fullPath.endsWith('/sso')) {
        router.replace('/sso')
        return
      }
    }
    let token = getToken()
    // 새로 화면이 불러오면 user Info 정보를 가져온다.
    // (토큰 값이 있어도 조회가 안될 수 있는 경우) request 상위에서 에러가 발생하면 무시된다.
    if (params.id || params.theme) {
      console.log('id를 파라매터로 넘겨 접근시 SetUserInfo처리 순서 변경')
    } else if (token) {
      store.dispatch('SetUserInfo').then(() => {
        console.log('SetUserInfo')
        if (params.theme === 'page') {
          console.log('단독 page호출시 GetMenus를 호출하지 않음')
        } else {
          store.dispatch('GetUserMenus', store.state.user.userId)
          // store.dispatch('GetMyMenu', store.state.user.userId)
        }
      })
    }
  },
  methods: {
    initPopup() {
      let found = false
      let start, end
      let i = 0
      while (i <= document.cookie.length) {
        start = i
        end = start + 'popup'.length
        if (document.cookie.substring(start, end) === 'popup') {
          found = true
          break
        }
        i++
      }
      this.component_show = !found
    },
    closeLayer() {
      if (document.getElementById('chkToday').checked) {
        let todayDate = new Date()
        todayDate.setDate(todayDate.getDate() + 5)
        document.cookie =
          'popup' +
          '=' +
          escape('no') +
          '; path=/; expires=' +
          todayDate.toGMTString() +
          ';'
      }
      this.component_show = false
    },
    setRealGridTheme(newValue) {
      let oldlink = document.getElementsByTagName('link').item(2)
      let newlink = document.createElement('link')
      newlink.setAttribute('rel', 'stylesheet')
      newlink.setAttribute('type', 'text/css')
      if (newValue) {
        newlink.setAttribute('href', 'realgrid/realgrid-dark.css')
      } else {
        newlink.setAttribute('href', 'realgrid/realgrid-style.css')
      }
      document
        .getElementsByTagName('head')
        .item(0)
        .replaceChild(newlink, oldlink)
    },
    callSetUserInfoTouchOne() {
      let token = getToken()
      if (!token) {
        router.replace('/login')
        return
      }
      // 새로 화면이 불러오면 user Info 정보를 가져온다.
      // (토큰 값이 있어도 조회가 안될 수 있는 경우) request 상위에서 에러가 발생하면 무시된다.
      store.dispatch('SetUserInfo').then(() => {
        // user 정보를 가져온 이후에 이동 및 메뉴 적용
        store
          .dispatch('GetMenus')
          .then(() => {
            this.$router.replace('/')
          })
          .catch(reject => {
            this.$router.replace('/forbidden')
          })
        // this.$store.dispatch('GetMenus').then(res => {
        //   // 메뉴 정보 있는 사용자만 home 으로 이동
        //   if (res.length > 0) {
        //     this.$router.push('/')
        //   } else {
        //     // 메뉴 정보가 없는 사용자는 권한이 없는 경우 이므로 권한 없음 페이지로 이동
        //     this.$router.push('/forbidden')
        //   }
        // })
        this.$store.dispatch('GetMyMenu', this.$store.state.user.userId)
        // 로그인 화면에서 바디 스크롤을 막아주는 클래스 지우기
        let bodyElement = document.getElementById('app')
        bodyElement.classList.remove('not_scroll')
      })
    }
  }
}
</script>
<style lang="scss">
@import '../node_modules/typeface-roboto/index.css';
@import 'src/assets/main.scss';
</style>
